import React from 'react';

export function PersonalMessage() {

    return (
        <>
            <div className={"ui main text container"} style={{"padding-top":"5em"}}>
                <img className="ui small left floated image transition visible"
                     data-src="/img/apil_pic2.png"
                     src="/img/apil_pic2.png">
                </img>

                <h1 className={"ui header"}>
                    A Message to Our Users
                </h1>
                <div className={"ui text container"}>
                    <h4 style={{"text-align":""}}>
                        Thank you for checking out the <b>Bank Agent Skill. </b>
                    </h4>
                </div>
                <br/>
                <br/>
                <div className={"ui text container"}>
                    <p style={{"text-indent":"justify"}}>
                            This app truly has been a labor of love for me. For many years, I've toiled through nights, mornings, and weekends to work on this project.
                        It is my great pleasure to finally get to meet you (of course, only by proxy through Alexa!).
                    </p>

                    <p style={{"text-indent":"justify"}}>
                            I look forward to support this app for the foreseeable future. Maintaining a complex app such as this
                        is far from being trivial. There are hundreds of software components to keep updated for security and operational reasons.
                        There can be many usage-related issues (<b>bugs</b>, as we call 'em) to fix, and multiple costs to cover for servers
                        and third-party services. Through them all, I hope to keep this project running very much alive.
                    </p>

                    <p style={{"text-indent":"justify"}}>
                        It is also with great excitement that I share that we are expecting our first daughter (<b>Summer K Tamang</b>) in a couple of months.
                        Becoming new parents, my ability to support this app may become even more limited. Thus, it is with some humility I ask that should
                        you encounter any issue, please exercise some patience, and kindly let me know how I can help! You may use the contacts page
                        or just email at support@voicesoftwares.com. I will do my best to squash these bugs as time and necessity permit.

                    </p>

                    <p style={{"text-indent":"justify"}}>
                        Finally, opportunity permitting, I hope to add many more exciting features to the Bank Agent skill. My mind
                        buzzes with all the new (<i>and useful</i>) things Bank Agent could help you with. For now, I just hope you will
                        find this skill become ever-more helpful in your daily life. Again, thank you very much!
                    </p>
                </div>
                <br/>
                <br/>
                <div className={"ui text container"}>
                    <p>
                        Yours Sincerely,<br/>
                        Apil Tamang
                    </p>

                </div>

            </div>
        </>
    )

}